import { combineAiDataSources } from "../hooks/summarySnapshot.mjs";
import React from "react"
import { useSummaryData } from "../hooks/useSummaryData"
import { ClassName_EUIRolling12MonthTrend } from './summaryChartClassnames';
import { EUIRolling12MonthTrendBaseChart } from "@/components/base-chart/EUIRolling12MonthTrendBaseChart/EUIRolling12MonthTrendBaseChart"

export const config = {
  title: 'EUI Rolling 12 Month Trend (kBtu/sqft-yr)',
}

export const EUIRolling12MonthTrendChart = ({
  period,
  endingMonth,
  disableTooltip = false
}) => {

  const electricitySource = useSummaryData("electricity", period, endingMonth);
  const { data: electricityData = { electricity: [] } } = electricitySource;
  const gasSource = useSummaryData("gas", period, endingMonth);
  const { data: gasData = { gas: [] } } = gasSource;

  return (
    <EUIRolling12MonthTrendBaseChart
      electricityData={electricityData.electricity}
      gasData={gasData.gas}
      title={config.title}
      className={ClassName_EUIRolling12MonthTrend}
      style={{ width: '100%', height: '100%' }}
      customOptions={disableTooltip ? { tooltip: { show: false } } : {}}
      aiContext={{
        pageId: "page.facility.utility.summary",
          ...combineAiDataSources(electricitySource, gasSource),
        chart: {
          chartId: "utility.combined.eui_trend",
          title: config.title,
          aliases: ["rolling EUI trend", "12 month EUI", "EUI 趋势图", "滚动12个月能耗强度"],
          chartType: "stacked_bar",
          description: "Rolling 12-month electricity and gas EUI components stacked by month.",
          filters: { period, ending_month: endingMonth },
          sourceOperationIds: ["utility.rolling_12_month_eui"],
          series: [
            {
              name: "Electricity",
              unit: "kBtu/sqft-yr",
              points: electricityData.electricity.map((item) => ({ label: item.month, value: item.rolling_eui })),
            },
            {
              name: "Gas",
              unit: "kBtu/sqft-yr",
              points: gasData.gas.map((item) => ({ label: item.month, value: item.rolling_eui })),
            },
          ],
          completeness: electricityData.electricity.length && gasData.gas.length ? "complete" : "partial",
          limitations: ["The displayed total is the sum of electricity and gas components for each month."],
        },
      }}
    />
  )
}
